export const switchViewMode = (currentViewMode, command) => {
  if (command === "collapse-tree") {
    if (currentViewMode === "main-page-fullView") {
      return "main-page-graphAndProps";
    }
    if (currentViewMode === "main-page-graphAndTree") {
      return "main-page-onlyGraph";
    }
  }
  if (command === "collapse-props") {
    if (currentViewMode === "main-page-fullView") {
      return "main-page-graphAndTree";
    }
    if (currentViewMode === "main-page-graphAndProps") {
      return "main-page-onlyGraph";
    }
  }
  if (command === "expand-tree") {
    if (currentViewMode === "main-page-onlyGraph") {
      return "main-page-graphAndTree";
    }
    if (currentViewMode === "main-page-graphAndProps") {
      return "main-page-fullView";
    }
  }
  if (command === "expand-props") {
    if (currentViewMode === "main-page-onlyGraph") {
      return "main-page-graphAndProps";
    }
    if (currentViewMode === "main-page-graphAndTree") {
      return "main-page-fullView";
    }
  }
};
